import React, { useState, useEffect } from "react";

import { useAlert } from "../../../hooks/useAlert";
import {
  FileManagerProvider,
  FileManager,
  NodesMap,
} from "../../../lib/file-manager";
import getDocumentNodes from "../utils/getDocumentNodes.ts";

interface DocumentsTabProps {
  caseId: string;
  orgId: string;
}

export const DocumentsTab: React.FC<DocumentsTabProps> = ({ caseId }) => {
  const { setAlert } = useAlert();
  const [nodes, setNodes] = useState<NodesMap>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadCaseFiles();
  }, [caseId]);

  const loadCaseFiles = async () => {
    setLoading(true);
    try {
      const nodesMap = await getDocumentNodes(caseId);
      setNodes(nodesMap);
    } catch (error) {
      setAlert({
        variant: "error",
        title: "Error",
        message:
          error instanceof Error ? error.message : "Failed to load files",
      });
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex min-h-[400px] items-center justify-center">
        <div className="text-center">
          <div className="mx-auto mb-4 h-12 w-12 animate-spin rounded-full border-4 border-solid border-brand-500 border-t-transparent"></div>
          <p className="text-gray-600 dark:text-gray-400">Loading files...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="h-[600px] rounded-2xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03] overflow-hidden">
      <FileManagerProvider initialNodes={nodes} caseId={caseId}>
        <FileManager />
      </FileManagerProvider>
    </div>
  );
};

export default DocumentsTab;
